import * as yup from 'yup';
import moment from 'moment';

export const validations = yup.object().shape({
  startDate: yup
    .string()
    .test(function(date) {
      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data início é obrigatória',
          path: 'startDate'
        });
      }

      return true;
    }),
  endDate: yup
    .string()
    .test(function(date) {
      const isSame = moment(date, 'YYYY-MM-DD').isSame(moment(this.parent.startDate, 'YYYY-MM-DD'), 'days');
      const isBefore = moment(date, 'YYYY-MM-DD').isBefore(moment(this.parent.startDate, 'YYYY-MM-DD'), 'days');

      if(!moment(date, 'YYYY-MM-DD').isValid()) {
        return this.createError({
          message: 'A data fim é obrigatória',
          path: 'endDate'
        });
      }

      if(isBefore) {
        return this.createError({
          message: 'A data fim precisa ser maior que a data início',
          path: 'endDate'
        });
      }

      if(isSame) {
        return true;
      }

      return true;
    }),
  endTime: yup
    .string()
    .test(function(time) {
      if(time == ' ') {
        return this.createError({
          message: 'A hora é obrigatória',
          path: 'endTime'
        });
      }

      return true;
    }),
  paymentMethodId: yup.string().required('O meio de pagamento é obrigatório'),
  entryType: yup.string().required('Entrada ou saída é obrigatório')
});

export const modalValidations = yup.object().shape({
  reason: yup
    .string()
    .required('O motivo é obrigatório'),
  password: yup
    .string()
    .required('A senha é obrigatória'),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) =>
      password ? schema.required('Confirme a senha') : schema
    )
    .oneOf(
      [yup.ref('password'), null],
      'A senha e a confirmação devem ser iguais'
    ),
  actionConsent: yup
    .boolean()
    .test(function(actionConsent) {
      if(!actionConsent) {
        return this.createError({
          message: 'Você precisa confirmar este campo',
          path: 'actionConsent'
        });
      }

      return true;
    })
});